module.exports = __webpack_public_path__ + "media/images/icon_user-6f256ce8d77e7d1fc03432ad4b3fab86.svg";